import { StyleSheet } from 'react-native';
import { getContrastYIQ } from '@oolio-group/design-common';
import theme from '../../common/theme';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      columnGap: 10,
      paddingVertical: 20,
      paddingHorizontal: 32,
      borderWidth: 1,
      borderRadius: theme.radius.m,
      backgroundColor: colors.elevation1,
      borderColor: colors.borderMuted,
      overflow: 'hidden',
    },
    primary: {
      backgroundColor: colors.primary,
      borderColor: colors.primary,
    },
    pressed: {
      transform: [{ scale: 0.95 }],
    },
    // eslint-disable-next-line react-native/no-color-literals
    disabled: {
      backgroundColor: colors.elevation2,
      borderColor: 'transparent',
    },
    label: {
      fontSize: 18,
      lineHeight: 26,
      textAlign: 'center',
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.medium,
    },
    labelPrimary: {
      color: getContrastYIQ(colors.primary),
    },
    labelDisabled: {
      color: colors.placeholder,
    },
  });
